import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { ErrorMessage, Loading } from '@Components';
import { useFetchData } from '@CustomHooks';
import { ConfigCPFR, ConfigOSA } from '@Models';
import { bopsApi } from '@Network';
import ConfigurationPolicyCPFR from './configurationPolicyCPFR';
import ConfigurationPolicyOSA from './configurationPolicyOSA';

interface ConfigurationPolicyContainerProps {
  policyId: string;
  type: string;
}

const ConfigurationPolicyContainer = ({ policyId, type }: ConfigurationPolicyContainerProps) => {
  const { t } = useTranslation();

  const fetchPolicyData = useCallback(() => {
    return bopsApi.getConfigurationPolicy(policyId, type);
  }, [policyId, type]);

  const { data, isLoading, error } = useFetchData(fetchPolicyData);
  if (isLoading) return <Loading title={t('Configuration.LoadingLink')} />;

  if (error || !data) {
    return <ErrorMessage internalMessage={`Unable to get configuration policy: ${error}`} />;
  }

  if (type === 'osa') {
    return <ConfigurationPolicyOSA config={data as ConfigOSA} />;
  }

  return <ConfigurationPolicyCPFR config={data as ConfigCPFR} />;
};

export default ConfigurationPolicyContainer;
